/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState, useEffect } from "react";
import "../pago-deducible.css";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { Grid } from "@material-ui/core";

const cadenaVacia = "";

const useStyles = makeStyles((theme) => ({
	modalBodyError: {
		padding: "32px 32px 32px 32px",
		textAlign: "center",
	},
	modalBodyPago: {
		padding: "32px 32px 32px 32px",
		textAlign: "center",
	},
	widthContainerError: {
		"& .MuiDialog-paper": {
			width: "412px",
			overflow: "hidden"
		}
	},
	widthContainerPago: {
		"& .MuiDialog-paper": {
			width: "720px",
			overflow: "hidden"
		}
	}
}));

const validValue = (value, callback) => {
	if (value) {
		return value;
	} else {
		return callback;
	}
}

const validWithButtons = (withButtons) => {
	let withButtonsObject = {
		withButtons: {
			actionButtons: false,
		},
	};
	if (withButtons && withButtons.actionButtons) {
		withButtonsObject = { ...withButtons };
	}
	return withButtonsObject;
}

const validWithButton = (withButton) => {
	let withButtonObject = {
		withButton: {
			actionButton: false,
		},
	};
	if (withButton && withButton.actionButton) {
		withButtonObject = { ...withButton };
	}
	return withButtonObject;
}

export default function ModalError(props) {
	const classes = useStyles();
	const [datosModal, setDatosModal] = useState({
		iconButton: false,
		openModal: false,
		msjTitle: cadenaVacia,
		msjBody: cadenaVacia,
		msjBody2: cadenaVacia,
		withButtons: {
			actionButtons: false,
			msjButton1: cadenaVacia,
			msjButton2: cadenaVacia,
		},
		withButton: {
			actionButton: false,
			msjButton1: cadenaVacia,
		},
		tipoPago: false,
	});

	const handleClose = (button) => {
		setDatosModal({
			...datosModal,
			openModal: false,
		});
		return button;
	};

	useEffect(() => {
		setDatosModal({
			iconButton: validValue(props.iconButton, false),
			tipoPago: validValue(props.tipoPago, false),
			openModal: validValue(props.openModal, false),
			msjTitle: validValue(props.msjTitle, cadenaVacia),
			msjBody: validValue(props.msjBody, cadenaVacia),
			msjBody2: validValue(props.msjBody2, cadenaVacia),
			withButtons: validWithButtons(props.withButtons),
			withButton: validWithButton(props.withButton),
		});
	}, [props]);

	return (
		<div>
			<Dialog
				maxWidth={'md'}
				disableEscapeKeyDown={true}
				disableBackdropClick
				className={!datosModal.tipoPago
					? classes.widthContainerError
					: classes.widthContainerPago}
				open={datosModal.openModal}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogContent
					className={
						!datosModal.tipoPago
							? classes.modalBodyError
							: classes.modalBodyPago
					}
					style={{ borderBottom: "1px solid #E8EEF8" }}
				>
					{datosModal.iconButton && (
						<IconButton
							onClick={() => props.handleClose("buttonIcon")}
							style={
								!datosModal.tipoPago
									? {
										color: "#FF6B0B",
										position: "fixed",
										marginTop: "-30px",
										marginLeft: "180px",
										backgroundColor: "#FEFEFE",
										border: "1px solid #A3AAB6",
										height: "36px",
										width: "36px",
									}
									: {
										color: "#FF6B0B",
										position: "fixed",
										marginTop: "-30px",
										marginLeft: "330px",
										backgroundColor: "#FEFEFE",
										border: "1px solid #A3AAB6",
										height: "36px",
										width: "36px",
									}
							}
						>
							<CloseOutlinedIcon
								style={{ width: "22px", height: "22px" }}
							></CloseOutlinedIcon>
						</IconButton>
					)}
					<p className="pTitleModalCvv">{datosModal.msjTitle}</p>
					<p className="pModalCvv">{datosModal.msjBody}</p>
					{datosModal.msjBody2 !== cadenaVacia && (
						<p className="pModalCvv" style={{ margin: "0px" }}>{datosModal.msjBody2}</p>
					)}
				</DialogContent>
				{datosModal.withButton.actionButton && (
					<Grid container item xs={12} sm={12} md={6} lg={6} style={{ padding: "16px" }}>
						<Grid item
							xs={12}
							sm={12}
							md={12}
							lg={12}>
							<Button
								className="button1ModalError"
								onClick={() => props.handleClose("button1")}
							>
								{datosModal.withButton.msjButton1}
							</Button>
						</Grid>
					</Grid>
				)}
				{datosModal.withButtons.actionButtons && datosModal.tipoPago && (
					<Grid container spacing={2} item xs={12} sm={8} md={8} lg={8} style={{ padding: "16px" }}>
						<Grid item
							xs={12}
							sm={5}
							md={5}
							lg={5}>
							<Button
								name={datosModal.withButtons.msjButton1}
								className={`${datosModal.tipoPago ? "button1ModalPago" : "button1ModalError"
									}`}
								onClick={() => props.handleClose("button1")}
							>
								{datosModal.withButtons.msjButton1}
							</Button>
						</Grid>
						<Grid item
							xs={12}
							sm={7}
							md={7}
							lg={7}>
							<Button
								name={datosModal.withButtons.msjButton2}
								className={`${datosModal.tipoPago ? "button2ModalPago" : "button2ModalError"
									}`}
								onClick={() => props.handleClose("button2")}
							>
								{datosModal.withButtons.msjButton2}
							</Button>
						</Grid>
					</Grid>
				)}
				{datosModal.withButtons.actionButtons && !datosModal.tipoPago && (
					<Grid container spacing={2} item xs={12} sm={10} md={10} lg={10} style={{ padding: "16px" }}>
						<Grid item
							xs={12}
							sm={6}
							md={6}
							lg={6}>
							<Button
								name={datosModal.withButtons.msjButton1}
								className={`${datosModal.tipoPago ? "button1ModalPago" : "button1ModalError"
									}`}
								onClick={() => props.handleClose("button1")}
							>
								{datosModal.withButtons.msjButton1}
							</Button>
						</Grid>
						<Grid item
							xs={12}
							sm={6}
							md={6}
							lg={6}>
							<Button
								name={datosModal.withButtons.msjButton2}
								className={`${datosModal.tipoPago ? "button2ModalPago" : "button2ModalError"
									}`}
								onClick={() => props.handleClose("button2")}
							>
								{datosModal.withButtons.msjButton2}
							</Button>
						</Grid>
					</Grid>
				)}
			</Dialog>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/pago-deducible-auto/modal-error/modal-error.cmpt.js